import { useEffect } from "react";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { initializeCSRFToken } from "./api/apiFactory";

import HomePage from "./userpage/Homepage"
import RentalsPage from "./userpage/RentalsPage";
import EventsPage from "./userpage/EventsPage";
import GalleryPage from "./userpage/GalleryPage";
import ContactPage from "./userpage/ContactPage";
import RentalDetailPage from "./userpage/RentalDetailPage";
import CheckoutPage from "./userpage/CheckoutPage";
import LoginPage from "./userpage/LoginPage";
import ForgotPasswordPage from "./userpage/ForgotPasswordPage";
import ResetPasswordPage from "./userpage/ResetPasswordPage";
import ComingSoonModal from "./components/ComingSoonModal";

// Dashboard Pages
import DashboardOverview from "./userpage/dashboard/DashboardOverview";
import MyRentals from "./userpage/dashboard/MyRentals";
import MyRentalsDetails from "./userpage/dashboard/MyRentalsDetails";
import UserRecentActivityPage from "./userpage/dashboard/UserRecentActivityPage";
import AccountSettings from "./userpage/dashboard/AccountSettings";

import { NotificationProvider } from "./context/NotificationContext";
import AdminDashboard from "./adminpage/AdminDashboard";
import CategoriesPage from "./adminpage/inventory/category/CategoriesPage";
import ProductsPage from "./adminpage/inventory/product/ProductsPage";
import AdminLogin from "./adminpage/AdminLogin";
import ForgotPassword from "./adminpage/ForgotPassword";
import ResetPassword from "./adminpage/ResetPassword";
import CatalogPage from "./adminpage/CatalogPage";
import AdminGalleryPage from "./adminpage/GalleryPage";
import ChangePassword from "./adminpage/ChangePassword";
import InvoicesPage from "./adminpage/invoices/InvoicesPage";
import CreateInvoicePage from "./adminpage/invoices/CreateInvoicePage";
import InvoiceDetailPage from "./adminpage/invoices/InvoiceDetailPage";
import InvoiceSettingsPage from "./adminpage/invoices/InvoiceSettingsPage";
import CustomersPage from "./adminpage/customers/CustomersPage";
import CustomerDetailPage from "./adminpage/customers/CustomerDetailPage";
import EditCustomerPage from "./adminpage/customers/EditCustomerPage";
import AuditLogsPage from "./adminpage/AuditLogsPage";
import AdminManagementPage from "./adminpage/AdminManagementPage";
import NotFound from "./userpage/NotFound";
import AdminProtectedRoutes from "./components/admin/AdminProtectedRoutes";
import AdminPublicRoutes from "./components/admin/AdminPublicRoutes";





const AppRoutes = () => {
  return (
    <Routes>
      {/* User Pages */}
      <Route exact path='/' element={<HomePage />} />
      <Route exact path='/rentals/' element={<RentalsPage />} />
      <Route exact path='/events/' element={<EventsPage />} />
      <Route exact path='/gallery/' element={<GalleryPage />} />
      <Route exact path='/contact/' element={<ContactPage />} />
      <Route exact path='/rental/:slug' element={<RentalDetailPage />} />
      <Route exact path='/checkout/' element={<CheckoutPage />} />
      <Route exact path='/login/' element={<LoginPage />} />
      <Route exact path='/forgot-password/' element={<ForgotPasswordPage />} />
      <Route exact path='/reset-password/' element={<ResetPasswordPage />} />

      {/* User Dashboard Routes */}
      <Route exact path='/dashboard/' element={<DashboardOverview />} />
      <Route path="/dashboard/rentals" element={<MyRentals />} />
      <Route path="/dashboard/rentals/:id" element={<MyRentalsDetails />} />
      <Route path="/dashboard/activity" element={<UserRecentActivityPage />} />
      <Route path="/dashboard/settings" element={<AccountSettings />} />
      <Route exact path='/dashboard/support/' element={<ComingSoonModal title="Support Coming Soon" message="Our support ticketing system is being finalized." onClose={() => window.history.back()} />} />


      {/* Admin Auth Pages (Public if not logged in) */}
      <Route exact path='/admin/login/' element={<AdminPublicRoutes><AdminLogin /></AdminPublicRoutes>} />
      <Route exact path='/admin/forgot-password/' element={<AdminPublicRoutes><ForgotPassword /></AdminPublicRoutes>} />
      <Route exact path='/admin/reset-password/' element={<AdminPublicRoutes><ResetPassword /></AdminPublicRoutes>} />

      {/* Protected Admin Pages */}
      <Route exact path='/admin/dashboard/' element={<AdminProtectedRoutes><AdminDashboard /></AdminProtectedRoutes>} />
      <Route exact path='/admin/inventory/categories/' element={<AdminProtectedRoutes><CategoriesPage /></AdminProtectedRoutes>} />
      <Route exact path='/admin/inventory/products/' element={<AdminProtectedRoutes><ProductsPage /></AdminProtectedRoutes>} />
      <Route exact path='/admin/catalog/' element={<AdminProtectedRoutes><CatalogPage /></AdminProtectedRoutes>} />
      <Route exact path='/admin/gallery/' element={<AdminProtectedRoutes><AdminGalleryPage /></AdminProtectedRoutes>} />
      <Route exact path='/admin/change-password/' element={<AdminProtectedRoutes><ChangePassword /></AdminProtectedRoutes>} />

      {/* Admin Invoices */}
      <Route exact path='/admin/invoices/' element={<AdminProtectedRoutes><InvoicesPage /></AdminProtectedRoutes>} />
      <Route exact path='/admin/invoices/create/' element={<AdminProtectedRoutes><CreateInvoicePage /></AdminProtectedRoutes>} />
      <Route exact path='/admin/invoices/settings/' element={<AdminProtectedRoutes><InvoiceSettingsPage /></AdminProtectedRoutes>} />
      <Route exact path='/admin/invoices/:id/' element={<AdminProtectedRoutes><InvoiceDetailPage /></AdminProtectedRoutes>} />

      {/* Admin Customers */}
      <Route exact path='/admin/customers/' element={<AdminProtectedRoutes><CustomersPage /></AdminProtectedRoutes>} />
      <Route exact path='/admin/customers/:id/' element={<AdminProtectedRoutes><CustomerDetailPage /></AdminProtectedRoutes>} />
      <Route exact path='/admin/customers/:id/edit/' element={<AdminProtectedRoutes><EditCustomerPage /></AdminProtectedRoutes>} />

      {/* Admin Audit Logs */}
      <Route exact path='/admin/audit-logs/' element={<AdminProtectedRoutes><AuditLogsPage /></AdminProtectedRoutes>} />

      {/* Admin Management */}
      <Route exact path='/admin/admins/' element={<AdminProtectedRoutes><AdminManagementPage /></AdminProtectedRoutes>} />

      {/* Catch-all 404 Page */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}




function App() {

  useEffect(() => {
    // Run CSRF init safely — never block render
    (async () => {
      try {
        await initializeCSRFToken();
      } catch (err) {
        console.error("⚠️ CSRF initialization failed:", err);
      }
    })();
  }, []);

  return (
    <NotificationProvider>
      <Router>
        <AppRoutes />
      </Router>
      <ComingSoonModal />
    </NotificationProvider>
  );
}




export default App;
